import { render, staticRenderFns } from "./ValidationModal.vue?vue&type=template&id=54eaba68&"
import script from "./ValidationModal.vue?vue&type=script&lang=js&"
export * from "./ValidationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports